import { render, staticRenderFns } from "./AgendaViewer.vue?vue&type=template&id=143c9711&scoped=true"
import script from "./AgendaViewer.vue?vue&type=script&lang=js"
export * from "./AgendaViewer.vue?vue&type=script&lang=js"
import style0 from "./AgendaViewer.vue?vue&type=style&index=0&id=143c9711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143c9711",
  null
  
)

export default component.exports